import MemberAppointmentInfoStep from './MemberAppointmentInfoStep.component';
import MemberAppointmentInfoStepPage from './MemberAppointmentInfoStep.page';

export default MemberAppointmentInfoStepPage;

export { MemberAppointmentInfoStep };
